import { isVue3SyncedWithVue2 } from './vue3router';
/**
 * 包裹 GogoRouteView：forcePath 内嵌时，等 vue3 与外层 vue2 fullPath 对齐后再挂载业务页，
 * 避免 setup/onMounted 读到 START_LOCATION / `/` 过渡态的空 query。
 * 必须放在 Vue3Adaptor 已 app.use(router) 之后的组件树内。
 */
export function createGatedGogoRouteView(Vue3, vueRouter, GogoRouteView) {
    const { computed, defineComponent, h } = Vue3;
    const { useRoute } = vueRouter;
    return defineComponent({
        name: 'GatedGogoRouteView',
        props: {
            gogoHost: {
                type: Object,
                default: undefined,
            },
            forcePath: {
                type: String,
                default: '',
            },
            forceProps: {
                type: [Object, Function],
                default: null,
            },
        },
        setup(props) {
            const route = useRoute();
            const ready = computed(() => {
                if (!props.forcePath)
                    return true;
                return isVue3SyncedWithVue2(route.fullPath);
            });
            return () => {
                if (!ready.value) {
                    return h('div', { class: 'flex items-center justify-center p-4 gap-4 flex-col' }, [h('t-loading')]);
                }
                return h(GogoRouteView, {
                    gogoHost: props.gogoHost,
                    forcePath: props.forcePath || undefined,
                    forceProps: props.forceProps,
                });
            };
        },
    });
}
